package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.ActiveLockpicking
import fr.manyverse.app.domain.model.LockpickingStatus
import fr.manyverse.app.domain.repository.LockpickingRepository

/**
 * Use case for unlocking the next lock in a lockpicking challenge.
 * Increments unlocked_count and transitions to SUCCESS if all locks are open.
 */
class UnlockLockUseCase(
    private val lockpickingRepository: LockpickingRepository
) {
    suspend operator fun invoke(
        lockpicking: ActiveLockpicking
    ): Result<ActiveLockpicking> {
        val newUnlockedCount = lockpicking.unlockedCount + 1
        val newStatus = if (newUnlockedCount >= lockpicking.lockCount) {
            LockpickingStatus.SUCCESS
        } else {
            LockpickingStatus.ACTIVE
        }

        return lockpickingRepository.unlockNext(
            lockpickingId = lockpicking.id,
            newUnlockedCount = newUnlockedCount,
            newStatus = newStatus
        )
    }
}
